export default __webpack_public_path__ + "static/media/hearing.031ea66e.png";